/*
 * 登录设备
 *
 * @Author:    1024创新实验室-主任：卓大
 * @Date:      2022-09-06 19:56:56
 * @Wechat:    zhuda1024
 * @Email:     lab1024@163.com
 * @Copyright  1024创新实验室 ( https://1024lab.net )，Since 2012
 */
export const LOGIN_DEVICE_ENUM = {
  PC: {
    value: 1,
    desc: '电脑端',
  },
  ANDROID: {
    value: 2,
    desc: '安卓',
  },
  APPLE: {
    value: 3,
    desc: '苹果',
  },
  H5: {
    value: 3,
    desc: 'H5',
  },
};

export default {
  LOGIN_DEVICE_ENUM,
};
